import React from 'react';

import ItemViewTop from "../../../../../layout/top/item-view-top/item-view-top";
import ErrorBoundary from "../../../../error-boundary";
import FieldProto from '../../../../fields/proto/field-proto';
import SessionCustomField from "../../../../model2/custom-field/session-custom-field";
import ApiCustomFields from "../../../../gd/api/custom-fields";


type Props = {
    field           : FieldProto // v1 !
    customField     : SessionCustomField
    onCloseClick    : callback,
    callback?       : callback
}

// const debug = "ModalCustomField_EditFieldV1"
const debug = false

export default class ModalCustomField_EditFieldV1 extends React.Component<Props> {

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }

    onSubmit = async (result:any) => {
        debug && console.log(debug, "onSubmit()", result)


        const response : any = await ApiCustomFields.update(this.props.customField.id, {
            name        : result.name,
            params      : result.params,
            access      : result.access
        }).promise()

        gd.modal.hide();

        this.props.callback && this.props.callback()

        return

    }

    render() {

        debug && console.log(debug,"render() field=", this.props.field)

        // @ts-ignore
        const FieldForm     = this.props.field.FormAddComponent;

        const topLeftContent = <div className="ui5-txt-not-important-small">Edit custom field</div>


        return (
            <div className="v4-container placement-middle ui5-iv view-custom-field" style={{width: 840}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.props.onCloseClick}/>

                <ErrorBoundary>

                     <FieldForm customField={this.props.customField} onSubmit={this.onSubmit} />

                </ErrorBoundary>
            </div>
        )
    }
}
